<template>
    <c-form-feedback v-if="invalidFeedback" :valid="false"
        ><small class="text-danger">{{ invalidFeedback }}</small>
    </c-form-feedback>
</template>
<script setup>
import { CFormFeedback } from '@coreui/vue-pro/dist/esm/components/form/index.js';

defineProps(['invalidFeedback']);
</script>
